import { Gallery } from 'react-gesture-gallery';

import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import CheckBox from 'components/Checkbox';

interface StepProps {
  isActive: boolean;
}

interface SaveProps {
  visible: boolean;
}

interface GalleryProps {
  index: number;
  length: number;
}

export const Container = styled.div`
  flex: 1;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export const MainContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
  }
`;

export const StyledGallery = styled(Gallery)<GalleryProps>`
  position: unset !important;
  width: unset !important;
  height: unset !important;
  user-select: none;

  .Gesture-view__pane {
    padding: 0 16px;
  }

  /* Previous */
  .Gesture-view__pane:nth-child(${({ index }) => index}) {
    transform: translateX(25px);
    transition: 0.2s ease-in-out;
  }

  /* Current */
  .Gesture-view__pane:nth-child(${({ index }) => index + 1}) {
    transform: translateX(0);
    transition: 0.2s ease-in-out;
  }

  /* Next */
  .Gesture-view__pane:nth-child(${({ index }) => index + 2}) {
    transform: translateX(-25px);
    transition: 0.2s ease-in-out;
  }

  .Gallery__Indicators {
    visibility: hidden;
  }

  .Gallery__NavigationArrow {
    display: none;
  }

  @media ${({ theme }) => theme.device.desktop} {
    .Gallery__NavigationArrow {
      display: block;
      top: unset !important;
      transform: none !important;

      &:nth-child(2) {
        opacity: ${({ index }) => (index === 0 ? 0 : 1)} !important;
      }

      &:nth-child(3) {
        opacity: ${({ index, length }) => (index === length - 1 ? 0 : 1)} !important;
      }
    }
  }
`;

export const StepperContainer = styled.div`
  display: flex;
  margin-top: 16px;
  height: 8px;
  flex-direction: row;
  justify-content: center;

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 22px;
  }
`;

export const Stepper = styled.div<StepProps>`
  width: 8px;
  background-color: ${(props) => (props.isActive ? ColorPalette.HEX.BrightOrange : ColorPalette.HEX.Manatee)};
  border-radius: 50%;
  margin: 0 8px;
`;

export const CheckBoxContainer = styled.div`
  padding-top: 32px;
  display: flex;
  flex-direction: row;
`;
export const CheckBoxStyled = styled(CheckBox)`
  display: flex;
  align-items: flex-start;
`;

export const CheckLabel = styled.label`
  padding: 0px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin-left: 8px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const FormContainer = styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;

  > div {
    flex: none;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 40px 16px 0 16px;
  }
`;

export const GroupButton = styled.div`
  margin-top: 16px;
  flex: 1 !important;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column-reverse;
`;

export const DeleteButtonContainer = styled.div`
  > div {
    padding: 28px 0 16px 0;
    border: none;
  }
`;

export const SaveChangesContainer = styled.div<SaveProps>`
  visibility: ${(props: SaveProps) => (props.visible ? 'visible' : 'hidden')};
`;
